import {
  fechVKYCDataByPrimaryWorkflowId,
  linkCrnToWorkflow,
} from "api/dashboardDetail";
import DynamicForm from "components/DynamicForm";
import Image from "lib/Image";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import option from "../../assets/images/option.svg";
import { ActionButtons } from "lib/ActionButtons";
import { setPopupData } from "redux/popupReducer";
import { setActiveNavTab,clearToastContainer } from "redux/dashBoardDetailReducer";
import { terminateOrRevokeApplication } from "api/dashboardDetail";
import { getPaymentAndUserInfo } from "api/payment";

function NavTabs(props) {
  const {
    form_groups,
    selectedData,
    activeTab,
    setActiveTab,
    options,
    custom_popups,
  } = props;

  const [showPopModal, setShowPopModal] = useState(false);
  const [popupState, setPopupState] = useState({});
  const [formErr, setFormErr] = useState({});

  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const { popupData } = useSelector((state) => state.popupReducer);
  const uploadedDocument = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const payment_details = useSelector(
    (state) => state.paymentReducer?.payment_details
  );

  const flattendData = {
    ...uploadedDocument,
    ...selectedData.subworkFlowInfo,
    subworkFlowInfo: selectedData.subworkFlowInfo,
    ...selectedData.primaryworkflow,
    ...selectedData,
    ...popupData,
    ...payment_details
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (activeTab === "") {
      setActiveTab(form_groups?.[0]?.title);
      dispatch(setActiveNavTab(form_groups?.[0]?.title));
      dispatch(clearToastContainer());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = useCallback((key) => {
    setActiveTab(key);
    dispatch(setActiveNavTab(key));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeTab === "V-KYC") {
      if (selectedData?.subworkFlowInfo?.primary_workflow_id) {
        const primary_workflow_id =
          selectedData?.subworkFlowInfo?.primary_workflow_id;
        dispatch(fechVKYCDataByPrimaryWorkflowId(primary_workflow_id));
      }
    }else if(activeTab === "Payment"){
      if (
        selectedData?.primaryworkflow?.payment_ids?.length > 0 &&
        Object.values(selectedData?.primaryworkflow?.payment_ids[0])?.length > 0
      ) {
        const payment_id = Object.values(
          selectedData?.primaryworkflow?.payment_ids[0]
        )?.[0];
        dispatch(
          getPaymentAndUserInfo({
            payment_id,
            user_id:
              selectedData?.subworkFlowInfo?.user_id ||
              selectedData?.subworkFlowInfo?.userId,
          })
        );
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }

    setFormErr(err);
  };

  const handleClick = (action) => {
    if (typeof action === "string" && action.includes("custom_popups::")) {
      const action_of = action.replace("custom_popups::", "");
      if (custom_popups?.[action_of]) {
        const customPopupConfig = custom_popups[action_of];
        const approveObj = {
          _of: action,
          config: customPopupConfig,
        };
        setPopupState(approveObj);
        approveObj?.config?.form_elements && setShowPopModal(true);
      }
    }
  };

  const handleLinkWithCrn = () => {
    const { subworkFlowInfo } = selectedData || {};
    const { config } = popupState || {};
    const { form_elements } = config || {};
    
    const request_body = {
      action: "link",
      primary_workflow_id: subworkFlowInfo?.primary_workflow_id || "",
    };
  
    if (form_elements) {
      for (const element of form_elements) {
        const { type, name } = element;
        const value = flattendData?.[name];
  
        if (type === "upload" && value) {
          request_body.uploadedDocument = {
            ...request_body.uploadedDocument,
            [name]: value,
          };
        } else if (type !== "upload" && value) {
          request_body[name] = value;
        }
      }
    }
  
    dispatch(linkCrnToWorkflow(request_body));
    setShowPopModal(false);
  };
  const handleDelinkWithCrn = () => {
    const { subworkFlowInfo, config } = selectedData || {};
    const { form_elements } = popupState?.config || {};
    const request_body = {
      action: "delink",
      primary_workflow_id: subworkFlowInfo?.primary_workflow_id || "",
      user_id: subworkFlowInfo?.user_id || "",
      crn: subworkFlowInfo?.crn,
    };
  
    if (form_elements) {
      for (const element of form_elements) {
        const { type, name } = element;
        const value = flattendData?.[name];
  
        if (type === "upload" && value) {
          request_body.uploadedDocument = {
            ...request_body.uploadedDocument,
            [name]: value,
          };
        } else if (type !== "upload" && value) {
          request_body[name] = value;
        }
      }
    }
  
    dispatch(linkCrnToWorkflow(request_body));
    setShowPopModal(false);
  };
  const handleTerminate = async (param) =>{
    let params = {
      primaryWorkflowId : flattendData?.primary_workflow_id,
      configuration_id : selectedData?.subworkFlowInfo?.configuration_id,
      organisation_id : flattendData?.organisation_id,
      loggedInUserId : loggedInUserInfo?.profileInfo['userId'],
      ...param
    }
    let res =  await terminateOrRevokeApplication(params)
    setShowPopModal(false);
    window.location.reload()
  }


  return (
    <>
    <div className="nav_tab_header px-lg-3 position-relative">
      <Tabs
        id="controlled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabChange}
        className="pb-4 detail-nav-tabs fs-15px .sticky1 position-sticky top-0 border-2 border-transparent bg-theme-grey z-index-2 overflow-x-scroll theme-scrollbar d-none"
      >
        {form_groups?.map(
          (_item) =>
            (_item?.show &&
            eval(_item?.show)) ? (
              <Tab
                eventKey={_item?.title}
                title={_item?.title}
                key={_item?.name}
                className="fs-15px"
              >
                {_item &&
                  _item?.form_groups?.map((item, index) => {
                    if (item?.type) {
                      return (
                        <Fragment key={index}>
                          <DynamicForm
                            formFields={item}
                            selectedData={selectedData}
                          />
                        </Fragment>
                      );
                    } else return <Fragment key={index}></Fragment>;
                  })}
              </Tab>
            ) : null
        )}
      </Tabs>
     
    </div>

<div className="pt-lg-5 position-absolute end-0 top-0 z-3 mt-lg-2 translate-middle-x">
<ActionButtons
  selectedData={flattendData}
  setSelectedData={setPopupData}
  popupConfig={popupState?.config || {}}
  form_buttons={[]}
  showPopModal={showPopModal}
  setShowPopModal={setShowPopModal}
  handleNext={handleClick}
  handleLinkWithCrn={handleLinkWithCrn}
  handleDelinkWithCrn={handleDelinkWithCrn}
  formErr={formErr}
  clearFieldError={clearFieldError}
  handleTerminate = {handleTerminate}
/>
{ activeTab?.toLowerCase() !== "v-kyc" && options && eval(options?.show) && (
  <DynamicForm
    formFields={options}
    selectedData={selectedData}
    triggerItem={
      <a className="cursor-pointer popover-btn  z-index-2">
        <Image className="option_button m-lg-3 mx-2" imageSrc={option} />
      </a>
    }
    handleItemClick={handleClick}
  />
)}
</div>
</>
  );
}

export default NavTabs;
